import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import Renderable from '../../../Component/Renderable';
import { AwaitIterators } from '../AnimationHelper';
import Point from '../../../Utility/Point';
import { MathHelper } from '../../../Utility/MathHelper';
import TransformComponent from '../../../Component/Transform';
import SpriteComponent from '../../../Component/Render/Sprite';
import Sprite from '../../../Prototype/Sprite';
import Interactable from 'Component/Interactable';

export class ToolboxTutorialClose extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        try {
            meta.destinationObject.getComponent(Interactable).enabled = false;
            const shine: GameObject = gameObject.find('shine');
            const item: GameObject = gameObject.find('unlocked_item');
            const text: GameObject = gameObject.find('unlocked_text');
            const btnContinue: GameObject = gameObject.find(
                'continue_btn_container'
            );

            const shineRenderable: SpriteComponent = shine.getComponent(
                SpriteComponent
            );

            const itemTransformComponentt: TransformComponent = item.getComponent(
                TransformComponent
            );

            const txtRenderable: Renderable = text.getComponent(Renderable);
            txtRenderable.alpha = 1;

            const btnRenderable: Renderable = btnContinue.getComponent(
                Renderable
            );
            btnRenderable.alpha = 1;

            // Fade out.
            const txtFadeOutTween: Tween = this.getTween(txtRenderable);
            txtFadeOutTween.to({ alpha: 0 }, 500).start(this.elapsedTime);

            const btnFadeOutTween: Tween = this.getTween(btnRenderable);
            btnFadeOutTween.to({ alpha: 0 }, 500);
            const shineFadeOutTween: Tween = this.getTween(shineRenderable);
            shineFadeOutTween.to({ alpha: 0 }, 500);

            const bezierDuration: number = 1000;
            const itemScaleTween: Tween = this.getTween(
                itemTransformComponentt.scale
            );
            itemScaleTween
                .to({ x: 1, y: 1 }, bezierDuration)
                .easing(Easing.Linear.None);

            const startPos: Point = itemTransformComponentt.container.position.clone() as Point;
            const itemBezierTween: Tween = this.createBezierTween(
                item,
                startPos,
                this.getDestinationPoint(item, meta.destinationObject),
                bezierDuration
            );
            itemBezierTween.onComplete(() => {
                const speechBubbleFadeOutTween: Tween = this.getTween(
                    meta.speechBubble.getComponent(Renderable)
                );
                speechBubbleFadeOutTween.to({ alpha: 1 }, 750);
                speechBubbleFadeOutTween.start(this.elapsedTime);
                meta.speechBubble.once(GameObjectEvent.DESTROYED, () => {
                    speechBubbleFadeOutTween.stop();
                });

                meta.destinationObject.getComponent(Renderable).visible = true;
                meta.destinationObject.getComponent(Interactable).enabled = true;
                item.destroy();
                btnContinue.destroy();
            });

            yield* AwaitIterators([
                this.startTween(txtFadeOutTween),
                this.startTween(btnFadeOutTween),
                this.startTween(shineFadeOutTween),
                this.startTween(itemBezierTween),
                this.startTween(itemScaleTween),
            ]);

            while (true) yield;
        } catch (e) {
            console.error(e);
        }
    }
    protected createBezierTween(
        gameObject: GameObject,
        startPos: Point,
        destination: Point,
        duration: number = 1000
    ): Tween {
        const element: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const bezierTween = this.getTween({ progress: 0 });

        const p1 = startPos;
        const p2 = new Point((startPos.x + destination.x) / 2, startPos.y);
        const p3 = new Point((startPos.x + destination.x) / 2, startPos.y);
        const p4 = destination;

        bezierTween
            .to({ progress: 1 }, duration)
            .onUpdate(t => {
                try {
                    const xy = MathHelper.cubicBezier(
                        t.progress,
                        p1,
                        p2,
                        p3,
                        p4
                    );
                    element.container.position.set(xy.x, xy.y);
                } catch (e) {
                    console.error(e);
                }
            })
            .easing(Easing.Sinusoidal.In);

        return bezierTween;
    }
    protected getDestinationPoint(
        gameObject: GameObject,
        destinationObject: GameObject
    ): Point {
        const parent: GameObject = gameObject.parent;
        const positioningSprite: GameObject = GameObject.Instantiate(Sprite, {
            texture: 'blank',
            pivot: new Point(0.5, 0.5),
            x: 675,
            y: 300,
            alpha: 0,
        });
        parent.addChild(positioningSprite);

        const destinationTransform: TransformComponent = destinationObject.getComponent(
            TransformComponent
        );
        const spriteTransform: TransformComponent = positioningSprite.getComponent(
            TransformComponent
        );

        destinationObject.addChild(positioningSprite);

        spriteTransform.position.copy(
            destinationTransform.pivot.clone() as Point
        );

        parent.addChild(positioningSprite);

        const destination: Point = spriteTransform.position.clone() as Point;
        positioningSprite.destroy();
        return destination;
    }
}
